import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
  },
  labelContainer: {
    display: 'flex',
    marginLeft: 8,
  },
  label: {
    color: theme.palette.text.primary,
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 8,
    marginRight: 8,
  },
  button: {
    borderWidth: 0,
    borderRadius: 20,
    '& :hover': {
      backgroundColor: '#CECECE',
      borderRadius: 20,
    },
  },
}));
